import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Distributor } from '../../shared/models/Distributor';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {
  createUserForm: FormGroup;
  NewUser: User;
  LoggedInUser: User;
  IsTolomaticUser: boolean;
  ValidationMessage: string;
  IsCreate: boolean;
  RedirectURL: string;
  Distributors: Distributor[];
  CurrentDistributor: Distributor;
  hideLoadingModal: boolean;
  HideUserForm: boolean;
  ShowValidationErrors: boolean;
  ReEnterPassword: string;
  constructor(private router: Router, private http: HttpService, private global: GlobalService, fb: FormBuilder) {
    var stateObject = this.router.getCurrentNavigation().extras.state;
    this.IsCreate = true;
    this.HideUserForm = false;
    this.hideLoadingModal = true;
    this.RedirectURL = "";
    if (stateObject && stateObject.User) {
      this.NewUser = <User>stateObject.User;
      this.IsCreate = false;
      
    }
    else {
      this.NewUser = new User();
      this.NewUser.Role = 'distributor';
      this.IsCreate = true;
    }

    if (stateObject && stateObject.redirectURL) {
      this.RedirectURL = stateObject.redirectURL;
    }


    this.createUserForm = fb.group({
      'userEmail': [this.NewUser.Email, Validators.compose([Validators.required, Validators.email])],
      'userPassword': [this.NewUser.Password, Validators.required],      
      'userFirstName': [this.NewUser.FirstName],
      'userLastName': [this.NewUser.LastName],
      'userPhone': [this.NewUser.Phone],
      'userCompany': [this.NewUser.Company],
      'userAddress1': [this.NewUser.Address1],
      'userAddress2': [this.NewUser.Address2],
      'userCity': [this.NewUser.City],
      'userState': [this.NewUser.State],
      'userZipCode': [this.NewUser.ZipCode],
      'userCountry': [this.NewUser.Country],
      'userDefaultUOM': [this.NewUser.DefaultUOM]
    });

    
  }

  async ngOnInit() {
    this.LoggedInUser = new User();
    this.ReEnterPassword = "";
    this.ShowValidationErrors = false;
    this.ValidationMessage = "";
    this.global.getCurrentUser().then(x => {
      this.LoggedInUser = x;
      this.LoadDistributors();
      if (this.LoggedInUser) {
        this.http.PostUserActivity(this.LoggedInUser.UserId.toString(), "Edit User Profile", "Load", "");
        this.IsTolomaticUser = this.LoggedInUser.IsTolomaticUser ?? false;
        if (!this.IsTolomaticUser) {
          this.CurrentDistributor = this.LoggedInUser.Distributor;
          this.NewUser.DistributorId = this.CurrentDistributor.CompanyId;
        }

      } else {
        if (this.router.url.indexOf("edit") >= 0) {
          this.router.navigate(['/']);
        }

        this.IsTolomaticUser = false;
      }
      this.hideLoadingModal = true;
    });
    
  }

  LoadDistributors() {
    this.http.GetDistributors().then(wrap => {
      debugger;
      this.Distributors = wrap.Content;
    });
  }

  Distributor_Change(event: any) {
    debugger;
    this.NewUser.DistributorId = event.value;
  }

  GetUserToEdit(userID: string) {
    this.http.GetUserById(userID).then(wrap => {
      this.NewUser = <User>wrap.Content;
    });
  }

  CreateUser() {

    this.markFormTouched(this.createUserForm);
    if (this.createUserForm.valid) {
      this.hideLoadingModal = false;
      this.AssignFormToUserObject();
      if (this.IsCreate) {
        //create user, api checks to see if email already exists so we just have to check status code and go from there

        if (this.ReEnterPassword != this.NewUser.Password) {
          return;
        }

        if (this.NewUser.Role == "administrator" && this.NewUser.DistributorId != null) {
          this.NewUser.Role = "distributor";
        }

        this.http.CreateUser(this.NewUser).then(wrap => {
          if (wrap.StatusCode == "200")//success
          {
            //set current user
            //this.global.setCurrentUser(wrap.Content);
            //redirect to project library
            this.HideUserForm = true;
            if (this.RedirectURL == "") {
              this.router.navigate(['/']);
            } else {
            this.router.navigate([this.RedirectURL]);
            }
          }
          else {//unsuccessful
            if (wrap.StatusCode == "400") {
              //display error message
              this.ValidationMessage = wrap.Message;
            }
            else {
              //server error

            }
          }
          this.hideLoadingModal = true;
        });
      }
      else {
        this.http.UpdateUser(this.NewUser).then(wrap => {
          if (wrap.StatusCode == "200") {
            if (this.RedirectURL != "") {
              this.router.navigate([this.RedirectURL]);
            }
            else {
              this.router.navigate(['/']);
            }
          }
          this.hideLoadingModal = true;
        });
      }
    }
  }

  AssignFormToUserObject() {
    this.NewUser.Email = this.createUserForm.controls['userEmail'].value;
    this.NewUser.Password = this.createUserForm.controls['userPassword'].value;
    this.NewUser.FirstName = this.createUserForm.controls['userFirstName'].value;
    this.NewUser.LastName = this.createUserForm.controls['userLastName'].value;
    this.NewUser.Phone = this.createUserForm.controls['userPhone'].value;
    this.NewUser.Address1 = this.createUserForm.controls['userAddress1'].value;
    this.NewUser.Address2 = this.createUserForm.controls['userAddress2'].value;
    this.NewUser.City = this.createUserForm.controls['userCity'].value;
    this.NewUser.State = this.createUserForm.controls['userState'].value;
    this.NewUser.Company = this.createUserForm.controls['userCompany'].value;
    this.NewUser.Country = this.createUserForm.controls['userCountry'].value;
    this.NewUser.DefaultUOM = this.createUserForm.controls['userDefaultUOM'].value;
    this.NewUser.ZipCode = this.createUserForm.controls['userZipCode'].value;

    //this.NewUser.DeliveryType = this.createUserForm.controls['userDeliveryType'].value;
    //this.NewUser.Distributor = this.createUserForm.controls['userDistributor'].value;
    //this.NewUser.SolidType = this.createUserForm.controls['userSolidType'].value;

  }

  UpdateUser() {
    this.hideLoadingModal = false;
    this.AssignFormToUserObject();

    //this.NewUser.DeliveryType = this.createUserForm.controls['userDeliveryType'].value;
    //this.NewUser.Distributor = this.createUserForm.controls['userDistributor'].value;
    //this.NewUser.SolidType = this.createUserForm.controls['userSolidType'].value;
    this.http.PostUserActivity(this.LoggedInUser.UserId.toString(), "Edit User Profile", "Edit User Save","");
    this.http.UpdateUser(this.NewUser).then(wrap => {
      if (wrap.StatusCode == "200") {
        if (this.RedirectURL != "") {
          this.router.navigate([this.RedirectURL]);
        } else {
          this.router.navigate(['/']);
        }
      }
      this.hideLoadingModal = true;
    });
  }

  CancelCreateUser() {
    if (this.RedirectURL != "") {
      this.router.navigate([this.RedirectURL]);
    }
    else if ((this.IsTolomaticUser || (this.LoggedInUser && this.LoggedInUser.Role == "distributor-manager")) && !this.IsCreate) {
      this.router.navigate(['/admin/manageusers']);
    }
    else {
      this.router.navigate(['/']);
    }
  }

  ReturnToHomePage() {
    this.router.navigate(['/']);
  }


  markFormTouched(group: FormGroup | FormArray) {
    Object.keys(group.controls).forEach((key: string) => {
      const control = group.controls[key];
      if (control instanceof FormGroup || control instanceof FormArray) { control.markAsTouched(); this.markFormTouched(control); }
      else { control.markAsTouched(); };
    });
  };

}
